import { observer } from "mobx-react";
import usePage from "../../../../../../components/layouts/base-page-layout/page-hook";
import { useEffect } from "react";
import currentPortalStore from "../../../../../../stores/current-portal-store";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import TranslationScope from "../../../../../../translation/translation-scope";
import PolicyConfirmationEditorContent from "./components/policy-confirmation-editor-content";

const PolicyConfirmationEditorPage: React.FC = observer(() => {
    const { setSubTitles } = usePage();

    useEffect(() => {
        setSubTitles([
            "Portal",
            "Content",
            "Return Portal",
            "Policy Confirmation",
        ]);
    }, [setSubTitles]);

    const {selectedLocale} = useTranslation();


    const scope = currentPortalStore.setting?.enablePortalV2
        ? "portal-edge"
        : "assistant";

    return (
        <TranslationScope scope={scope} locale={selectedLocale}>
            <PolicyConfirmationEditorContent isPortalEdgeSelected={!!currentPortalStore.setting?.enablePortalV2} />
        </TranslationScope>
    );
});

export default PolicyConfirmationEditorPage;
